import Swiper from "swiper";

import {
    Navigation,
    EffectFade,
    FreeMode,
    Pagination,
    Keyboard,
    Autoplay,
} from "swiper/modules";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "swiper/css/a11y";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import "swiper/css/navigation";
import "swiper/css/keyboard";
import "swiper/css/pagination";

class OpeningTimesBlock {
    constructor(element) {
        // Class properties.
        this.timeBlockMarkUp = element;

        this.pagination =
            this.timeBlockMarkUp.querySelector(".swiper-pagination");

        this.createCarousel();
    }

    createCarousel() {
        this.reviewCarousel = new Swiper(this.timeBlockMarkUp, {
            modules: [Pagination, Navigation, EffectFade, Keyboard, Autoplay],
            pagination: {
                el: this.pagination,
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="` + className + `"></span>`;
                },
            },
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            loop: true,
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const timeBlockCarousels = document.querySelectorAll(
        `[data-carousel="times-block"]`,
    );

    if (timeBlockCarousels.length) {
        timeBlockCarousels.forEach((element) => {
            new OpeningTimesBlock(element);
        });
    }
});

export default OpeningTimesBlock;
